<div class="grid grid-cols-10 grid-rows-1">
  <div class="col-span-4 h-screen flex flex-col justify-center items-center">
    <div class="w-[25vw] h-[30vh] flex justify-center">
      <img class="h-[30vh]"
           src="img/logo_tierphys.svg"
           alt="TierPhys Logo"/>
    </div>
    <div class="w-[25vw] h-[30vh]">
      <p-card [style]="{padding:0, margin:0}">
        <div class="w-[25vw] h-[30vh]">
          <form class="h-[100%] flex flex-col justify-around items-center" [formGroup]="loginForm"
                (ngSubmit)="onSubmit()">
            <div class="w-[90%]">
              <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start"> {{ 'Login.Username'|translate }}</div>
              <input id="username" type="text" variant="filled" fluid="true" pInputText pSize="large"
                     formControlName="username"/>
            </div>
            <div class="w-[90%]">
              <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start">{{ 'Login.Password'|translate }}</div>
              <p-password id="password" [feedback]="false" [toggleMask]="true" variant="filled"
                          fluid="true" size="large"
                          formControlName="password"/>
            </div>
            <p-button type="submit" size="large" [disabled]="!loginForm.valid" label="{{'Login.Login'|translate}}"/>
          </form>
        </div>
      </p-card>
    </div>
  </div>
  <div class="col-span-6 h-screen flex bg-cyan-700">
  </div>
</div>
